import { createSingleton } from './singleton';
class ServicesRegistry {
    _entries;
    constructor() {
        this._entries = [];
    }
    register(service, ident) {
        const idx = this._entries.findIndex(e => e.service === service);
        if (idx === -1) {
            this._entries.push({
                ident,
                service,
                debug: String(new Error().stack)
                    .split('\n')
                    .slice(1)
                    .join('\n'),
            });
        }
    }
    unregister(service) {
        const idx = this._entries.findIndex(e => e.service === service);
        if (idx !== -1) {
            this._entries.splice(idx, 1);
        }
    }
    static register(service, ident) {
        this.getInstance().register(service, ident);
    }
    static unregister(service) {
        this.getInstance().unregister(service);
    }
    static getInstance = createSingleton(() => new ServicesRegistry(), '__servicesRegistry');
}
export default ServicesRegistry;
